var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDate28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m9 3-.001 2h11V3h1v2H23.5A2.5 2.5 0 0 1 26 7.5v16a2.5 2.5 0 0 1-2.5 2.5h-18A2.5 2.5 0 0 1 3 23.5v-16A2.5 2.5 0 0 1 5.5 5h2.499V3h1Zm10.998 3v2h1V6H23.5A1.5 1.5 0 0 1 25 7.5V11H4V7.5A1.5 1.5 0 0 1 5.5 6h2.499v2h.999V6h11ZM25 12v11.5a1.5 1.5 0 0 1-1.5 1.5h-18A1.5 1.5 0 0 1 4 23.5V12h21Z",
  clipRule: "evenodd"
})));
export { SvgDate28 as ReactComponent };
export default __webpack_public_path__ + "0771efff950082b70d2a72ff0c0cd982.svg";